"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../../utilities/CoreProps");
var _TooltipBubble = _interopRequireDefault(require("../../elements/TooltipBubble"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Field = _ref => {
  let {
    label,
    id,
    name,
    required,
    tooltipText,
    isHorizontal,
    size,
    grouped,
    hasAddons,
    renderAs,
    className,
    textColor,
    children
  } = _ref;
  const RenderAs = renderAs;
  const classNames = (0, _classnames.default)({
    'is-horizontal': isHorizontal,
    'has-addons': hasAddons,
    'is-grouped': grouped
  });
  const labelClassNames = (0, _classnames.default)({
    [`is-${size === 'default' && isHorizontal ? 'normal' : size}`]: size,
    [`has-text-${textColor}`]: textColor
  });
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('field', className, classNames) || undefined
  }, isHorizontal && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('field-label', labelClassNames) || undefined
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "label",
    htmlFor: id || name
  }, label, required && /*#__PURE__*/_react.default.createElement("span", null, " *"), tooltipText && /*#__PURE__*/_react.default.createElement(_TooltipBubble.default, {
    text: tooltipText,
    tipPosition: "right",
    position: "middle"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "field-body"
  }, children)), !isHorizontal && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)('label', labelClassNames) || undefined,
    htmlFor: id || name
  }, label, required && /*#__PURE__*/_react.default.createElement("span", null, " *"), tooltipText && /*#__PURE__*/_react.default.createElement(_TooltipBubble.default, {
    text: tooltipText,
    tipPosition: "right",
    position: "middle"
  })), children));
};
Field.propTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  tooltipText: _propTypes.default.string,
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  textColor: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  className: _propTypes.default.string,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['default', 'normal', 'small', 'medium', 'large']), _propTypes.default.string]),
  isHorizontal: _propTypes.default.bool,
  required: _propTypes.default.bool,
  hasAddons: _propTypes.default.bool,
  grouped: _propTypes.default.bool
};
Field.defaultProps = {
  renderAs: 'div',
  size: 'default'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Field);
//# sourceMappingURL=Field.js.map